import { ArtistMinifiedType as ApiArtistMinifiedType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { ArtistMinifiedType } from './types';

export const mapArtistMinifiedType = (
  apiArtist: ApiArtistMinifiedType
): ArtistMinifiedType => {
  return {
    id: apiArtist.id,
    name: apiArtist.name,
    agent: apiArtist.agent ? mapLinkableEntityType(apiArtist.agent) : null,
    buyer: apiArtist.buyer ? mapLinkableEntityType(apiArtist.buyer) : null,
    manager: apiArtist.manager
      ? mapLinkableEntityType(apiArtist.manager)
      : null,
    projectLead: apiArtist.projectLead
      ? mapLinkableEntityType(apiArtist.projectLead)
      : null,
    coordinator: apiArtist.coordinator
      ? mapLinkableEntityType(apiArtist.coordinator)
      : null,
  };
};
